import React, { useEffect, useRef, useState } from "react";
import { ModalPopup } from "../modal/modalPopup";


type DoNotPermitPurchaseProps = {
  restrictedLink: string;
  restrictedMessage?: string;
};

export const DoNotPermitPurchase = (props: DoNotPermitPurchaseProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const messageRef = useRef<HTMLDivElement>(null);

  const [modalState, setModalState] = useState(false);
  const [displayModal, setDisplayModal] = useState<boolean>(false);

  useEffect(() => {
    if (!modalState &&
      (containerRef?.current?.getBoundingClientRect().bottom ?? 0) <
        (messageRef?.current?.getBoundingClientRect().bottom ?? 0)
    ) {
        setModalState(true);      
    }
  }, [modalState, props.restrictedMessage]);

  return (
    <div className={`unavailable-container ${modalState ? 'display-modal' : ''}`}  ref={containerRef}>
      <div className="font-weight-bold account-unavailable">
        {props.restrictedLink}
      </div>
      {props.restrictedMessage && (
        <>
          <div
            className="account-text"
            suppressHydrationWarning
            dangerouslySetInnerHTML={{ __html: props.restrictedMessage }}
            ref={messageRef}
          />
          {modalState && (
            <span className="modal-trigger">
              ... <u onClick={() => {
                setDisplayModal(true);
                }}>Read More</u>
            </span>
          )}
          {displayModal && <ModalPopup
            header={props.restrictedLink}
            boxShadow
            setShow={displayModal}
            className="unavailable-modal"
            actionItem={() => setDisplayModal(false)}
            actionItemText="OK"
            onClose={() => setDisplayModal(false)}
            customZIndex={1500}
          >
            <div
              suppressHydrationWarning
              dangerouslySetInnerHTML={{ __html: props.restrictedMessage }}
              ref={messageRef}
            />
          </ModalPopup>}
        </>
      )}
    </div>
  );
};
